import React from 'react';

interface SrfIndicatorProps {
    patient: PatientType;
}
export function SrfIndicator({ patient }: SrfIndicatorProps) {
    return patient?.metadata?.Is_Social_Risk === true ? (
        <span
            className="srf-indicator ms-2"
            title={`Social Risk Factor (MY): ${patient?.metadata?.Srf_Prp_Display}`}
        >
            S
        </span>
    ) : null;
}
